import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import BookingStatusPill from 'features/BookingDetails/BookingStatusPill'
import Reservation from 'features/BookingDetails/Reservation'
import { useEffect, useState } from 'react'
import bookingsApi from 'services/api/bookings'

import styles from './ReservationCompareDialog.module.scss'

const ReservationCompareDialog = ({ priorBookingId, bookingId, onClose }) => {
  const [isPriorBookingLoading, setIsPriorBookingLoading] = useState(true)
  const [isPriorBookingErred, setIsPriorBookingErred] = useState(false)
  const [priorBooking, setPriorBooking] = useState(null)

  const [isBookingLoading, setIsBookingLoading] = useState(true)
  const [isBookingErred, setIsBookingErred] = useState(false)
  const [booking, setBooking] = useState(null)

  useEffect(() => {
    setIsPriorBookingLoading(true)
    setIsPriorBookingErred(false)

    bookingsApi
      .one({ bookingId: priorBookingId })
      .then(booking => {
        setPriorBooking(booking)
      })
      .catch(() => {
        setIsPriorBookingErred(true)
      })
      .finally(() => {
        setIsPriorBookingLoading(false)
      })
  }, [priorBookingId])

  useEffect(() => {
    setIsBookingLoading(true)
    setIsBookingErred(false)

    bookingsApi
      .one({ bookingId })
      .then(booking => {
        setBooking(booking)
      })
      .catch(() => {
        setIsBookingErred(true)
      })
      .finally(() => {
        setIsBookingLoading(false)
      })
  }, [bookingId])

  if (isPriorBookingLoading || isBookingLoading) {
    return <LoadingIndicator />
  }

  return (
    <ConfirmationDialog
      onClose={onClose}
      maxWidth={1300}
      theme="blacklist"
      title="Reservation comparison"
      positiveMessage="Close"
    >
      <div className={styles.dialogInner}>
        <div className={styles.reservationHolder}>
          <h2 className={styles.reservationTitle}>
            {priorBooking.isAgency ? 'OTA booking' : 'Direct booking'}{' '}
            {!isPriorBookingErred && <BookingStatusPill status={priorBooking.status} />}
          </h2>
          {!isPriorBookingErred && <Reservation {...priorBooking} />}
          {isPriorBookingErred && <p>Something went wrong while loading the booking</p>}
        </div>
        <div className={styles.reservationHolder}>
          <h2 className={styles.reservationTitle}>
            {booking.isAgency ? 'OTA booking' : 'Direct booking'}{' '}
            {!isBookingErred && <BookingStatusPill status={booking.status} />}
          </h2>
          {!isBookingErred && <Reservation {...booking} startTimelineFromInvite />}
          {isBookingErred && <p>Something went wrong while loading the booking</p>}
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default ReservationCompareDialog
